var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-card',{attrs:{"title":_vm.$t('network-connection'),"sub-title":_vm.$t('disconnected'),"list-items":_vm.listItems,"iconName":"mdi-access-point","mainItemText":_vm.$t('dashboard-network-connection-main-text'),"statusValue":_vm.goodDevicesPercentage,"errorMessage":_vm.errorMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }